export default __webpack_public_path__ + "static/media/omission.be6ab7d9.svg";